// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5r-6";
export var headerCell = "_5r-2";
export var loadingStateContent = "_5r-8";
export var rowWrapper = "_5r-4";
export var stickyAggregationCell = "_5r-b";
export var stickyAggregationRow = "_5r-7";
export var stickyColumnCell = "_5r-a";
export var stickyColumnHeaderCell = "_5r-9";
export var table = "_5r-1";
export var virtualRowWrapper = "_5r-5";
export var virtualTableContainer = "_5r-0";
export var white = "_5r-3";